import Button from '@material-ui/core/Button'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import {useEditMode} from 'Event/EditModeProvider'
import React from 'react'
import {SidebarNavProps} from 'Event/template'
import {generateHashId} from 'lib/crypto/hash'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function NewSidebarNavButton(props: {
  className?: string
  nav: SidebarNavProps
  navId: string
}) {
  const {navId} = props
  const isEditMode = useEditMode()
  const saveTemplate = useSaveTemplate()
  const addTranslation = useAddTranslation()

  if (!isEditMode) {
    return null
  }

  const addButton = () => {
    generateHashId([
      'simple_blog_sidebar_nav_button',
      Math.random().toString(),
      Date.now().toString(),
    ]).then((id) => {
      const componentId = `sidebar_button_${id}`
      const button: NavButtonWithSize = {
        text: `{{${componentId}_text}}`,
        link: '',
        rules: [],
        size: 12,
        isAreaButton: false,
        isImageUpload: false,
        isFormButton: false,
        isCertificateButton: false,
        areaId: null,
        formId: null,
        actionId: null,
        certificateId: null,
        isVisible: true,
        infusionsoftTag: null,
        mailchimpTag: null,
        zapierTag: null,
        highLevelTag: null,
        webhook: null,
        disableHover: true,
        backgroundColor: '#000000',
        hoverBackgroundColor: '#000000',
        hubspotTag: null,
        activeCampaignTag: null,
        convertKitTag: null,
        ontraportTag: null,
      }

      saveTemplate({
        sidebarItems: {
          [navId]: {
            buttons: {
              [componentId]: button,
            },
          },
        },
        localization: addTranslation({
          [`${componentId}_text`]: 'Button',
        }),
      })
    })
  }
  return (
    <Button
      fullWidth
      size="large"
      variant="contained"
      color="secondary"
      aria-label="add sidebar nav button"
      onClick={addButton}
      className={props.className}
    >
      New Button
    </Button>
  )
}
